import { render, staticRenderFns } from "./memopelepasanjaminansebagianfrm.vue?vue&type=template&id=6ab24e78&"
import script from "./memopelepasanjaminansebagianfrm.vue?vue&type=script&lang=js&"
export * from "./memopelepasanjaminansebagianfrm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports